<template>
    <!-- <particles-bg type="random" :bg="true"/> -->
    <!-- <vue-particles
    class="login-background"
    color="#409EFF"
    :particleOpacity="0.7"
    :particlesNumber="60"
    shapeType="circle"
    :particleSize="6"
    linesColor="#409EFF"
    :linesWidth="1"
    :lineLinked="true"
    :lineOpacity="0.4"
    :linesDistance="150"
    :moveSpeed="3"
    :hoverEffect="true"
    hoverMode="grab"
    :clickEffect="true"
    clickMode="push">
    </vue-particles> -->
    <div class="login-all">
        <!-- 左侧：动画角色 -->
        <div class="login-left">
            <div class="left-content">
                <AnimatedCharacters
                    :is-typing="isTyping"
                    :has-secret="!!password"
                    :secret-visible="showPassword"
                />
                <div class="brand-text">MOOBY YOHO</div>
                <div class="brand-subtitle">欢迎回来</div>
            </div>
        </div>
        <!-- 右侧：登录表单 -->
        <div class="login-right">
            <transition name="el-zoom-in-top" mode="out-in">
                <div class="login-card" :key="isChangePass ? 'login' : 'forgot'">
                    <!-- 登录 -->
                    <template v-if="isChangePass">
                        <div class="login-header">MOOBY YOHO</div>
                        <div class="login-form">
                            <div class="form-item">
                                <label class="form-label">用户名</label>
                                <el-input v-model="username" clearable auto-complete="off" @focus="isTyping = true" @blur="isTyping = false"></el-input>
                            </div>
                            <div class="form-item">
                                <label class="form-label">密码</label>
                                <el-input ref="loginInput" placeholder="请输入密码" v-model="password" :type="showPassword ? 'text' : 'password'" @keyup.enter.native="doLogin" auto-complete="off">
                                    <i slot="suffix" class="el-input__icon el-icon-view" :class="{'is-active': showPassword}" style="cursor:pointer" @click="showPassword = !showPassword"></i>
                                </el-input>
                            </div>
                            <div class="forgot-password" @click="changePass">忘记密码？</div>
                            <el-button type="primary" class="login-btn" @click="doLogin" :loading="load">登录</el-button>
                        </div>
                    </template>
                    <!-- 忘记密码 -->
                    <template v-else>
                        <div class="login-header">
                            <span class="back-btn" @click="changePass"><i class="el-icon-back"></i></span>
                            修改密码
                        </div>
                        <div class="login-form">
                            <div class="form-item">
                                <label class="form-label">手机号码</label>
                                <el-input v-model="username" placeholder="请输入手机号码"  @focus="isTyping = true" @blur="isTyping = false">
                                    <el-select v-model="phonetype" placeholder="请选择" slot="prepend" style="width:70px;">
                                        <el-option key="86" label="+86" value="86"></el-option>
                                        <el-option key="1" label="+1"   value="1"></el-option>
                                    </el-select>
                                </el-input>
                            </div>
                            <div class="form-item">
                                <label class="form-label">新密码</label>
                                <el-input v-model="newPassword" placeholder="请输入新密码" :type="showPassword ? 'text' : 'password'">
                                    <i slot="suffix" class="el-input__icon el-icon-view" :class="{'is-active': showPassword}" style="cursor:pointer" @click="showPassword = !showPassword"></i>
                                </el-input>
                            </div>
                            <div class="form-item">
                                <label class="form-label">验证码</label>
                                <el-input placeholder="请输入验证码" v-model="code" @keyup.enter.native="resetPsw" ref="forgetBlur">
                                    <el-button slot="append" @click="getCode" style="width:120px" :disabled="isDsiabled">{{codeSecond}}</el-button>
                                </el-input>
                            </div>
                            <el-button type="primary" class="login-btn" :loading="forgetLoad" @click="resetPsw">确认修改</el-button>
                        </div>
                    </template>
                </div>
            </transition>
        </div>
    </div>
</template>

<style scoped>
.login-all {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
}

/* ===== 左侧：角色区域 ===== */
.login-left {
    width: 47%;
    min-width: 500px;
    background:
        /* 网格线 */
        linear-gradient(rgba(255, 255, 255, 0.04) 1px, transparent 1px),
        linear-gradient(90deg, rgba(255, 255, 255, 0.04) 1px, transparent 1px),
        /* 底色 */
        linear-gradient(135deg, #545C64 0%, #3d4349 100%);
    background-size: 25px 25px, 25px 25px, 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;
}

.left-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
}

.brand-text {
    font-size: 32px;
    font-weight: 700;
    color: #F4C84D;
    letter-spacing: 6px;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.brand-subtitle {
    font-size: 16px;
    color: rgba(255, 255, 255, 0.6);
    letter-spacing: 3px;
}

/* ===== 右侧：表单区域 ===== */
.login-right {
    flex: 1;
    background: #f5f7fa;
    display: flex;
    align-items: center;
    justify-content: center;
}

.login-card {
    width: 420px;
    padding: 40px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 8px 40px rgba(0, 0, 0, 0.08);
}

.login-header {
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 20px;
    color: #545C64;
    font-weight: 700;
    border-bottom: 1px solid #eee;
    position: relative;
    overflow: hidden;
}

.login-form {
    padding-top: 10px;
}

.form-item {
    margin-top: 20px;
}

.form-label {
    display: block;
    line-height: 30px;
    font-size: 14px;
    color: #606266;
    font-weight: 500;
}

.forgot-password {
    margin-top: 12px;
    text-align: center;
    line-height: 30px;
    font-size: 14px;
    color: #545C64;
    cursor: pointer;
}
.forgot-password:hover {
    color: #F4C84D;
}

.login-btn {
    margin-top: 24px;
    width: 100%;
}

.back-btn {
    position: absolute;
    top: 0;
    left: 0;
    width: 50px;
    height: 100%;
    line-height: 50px;
    text-align: center;
    border-top-left-radius: 12px;
    cursor: pointer;
}
.back-btn:hover {
    background-color: #545C64;
    color: #fff;
}

/* ===== Element UI 组件主题覆盖 ===== */
/* 主按钮 - 深灰 */
.login-right >>> .el-button--primary {
    background-color: #545C64;
    border-color: #545C64;
}
.login-right >>> .el-button--primary:hover,
.login-right >>> .el-button--primary:focus {
    background-color: #3d4349;
    border-color: #3d4349;
}
.login-right >>> .el-button--primary.is-loading .el-icon-loading {
    color: #F4C84D;
}

/* 输入框焦点 - 金色 */
.login-right >>> .el-input__inner:focus {
    border-color: #F4C84D;
}
.login-right >>> .el-input.is-active .el-input__inner {
    border-color: #F4C84D;
}

/* 密码可见图标激活状态 */
.login-right >>> .el-input__icon.is-active {
    color: #F4C84D;
}

/* 选择器前缀 */
.login-right >>> .el-select .el-input .el-input__inner:focus {
    border-color: #F4C84D;
}
</style>

<script>

import { login } from '@/api/login.js'
import AnimatedCharacters from '../../components/AnimatedCharacters/index.vue'
// import { ParticlesBg } from "particles-bg-vue"
export default {
    // components: { ParticlesBg },
    components: { AnimatedCharacters },
    data: function(){
        return {
            isTyping: false,  //是否正在输入
            showPassword: false, //是否显示密码
            username: '',
            password: '',
            load:false,   //判断 登陆 按钮是否显示 loading
            newPassword:'',  //忘记密码  新密码
            forgetLoad:false, //判断 忘记密码 按钮是否显示 loading
            phonetype:'86',
            codeSecond: '获取验证码',   //验证码 读秒 
            code: '',       //验证码
            isChangePass: true,
            // 禁用获取验证码
            isDsiabled: false,

        }
    },
    methods: {
        changePass() {
            // 修改密码
            this.isChangePass = !this.isChangePass
        },
        getCode(){
            
        },
        timeDown() {
            // 倒计时
            // 禁用获取验证码
            this.isDsiabled = true
            this.codeSecond = 60 + 's'
            var codeTemp = 59
            const that = this
            const timer = setInterval(function(){
                that.codeSecond = codeTemp + 's'
                codeTemp--
                if(codeTemp == 0){
                    that.codeSecond = '获取验证码'
                    // 取消禁用验证码
                    that.isDsiabled = false
                    clearInterval(timer)
                }
            },1000)
        },
        doLogin(){
            this.$refs.loginInput.blur();
            if(this.username == ""){
                this.$message.error('警告哦，请先输入用户名');
                return false
            }
            if(this.password == ""){
                this.$message.error('警告哦，请先输入新密码');
                return false
            }
         
            

            let params = {
                account:this.username,
                password:this.password,
            }
            this.load = true;
            login(params).then(res => {
                if(res) {
                    this.setToken(res.access_token);
                    this.$router.push({path:'/account/index'})
                }
                
            }).finally( () => {
                this.load = false;
            })
        },
        resetPsw(){
            this.$refs.forgetBlur.blur();
            if(this.username == ""){
                this.$message.error('警告哦，请填写用户名');
                return false
            }
            if(this.newPassword == ""){
                this.$message.error('警告哦，请填写密码');
                return false
            }
            if(this.code == ""){
                this.$message.error('警告哦，请先输入验证码');
                return false
            }
            // let params = {
            //     phone:this.username,
            //     phonetype:this.phonetype,
            //     code:this.code
            // }
            // this.forgetLoad = true;
            // checkCode(params).then(res => {
            //     if(res.status === 1){
            //         let data = {
            //             phone:this.username,
            //             password:this.newPassword
            //         }
            //         resetPassword(data)
            //         .then(res => {
            //             this.forgetLoad = false;
            //             if(res.status === 1){
            //                 this.$message('重置密码成功');
            //                 this.isChangePass = !this.isChangePass
            //             }else{
            //                 this.$message.error(`Opps，${res.msg}`);
            //             }
            //         })
            //     }else{
            //         this.forgetLoad = false;
            //         this.$message.error(`Opps，${res.msg}`);
            //     }
            // })
        }
    },

}
</script>



